import { Create } from "react-admin";
import { QuoteForm } from "./_form";
import { useAdmin } from "../../hooks/admin";

export const QuoteCreate = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("quotes.create")) return null;

  return (
    <Create redirect="show">
      <QuoteForm />
    </Create>
  );
};
